import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  SimpleChanges,
  SimpleChange,
  OnChanges,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import {
  OfferEntryData,
  GridRow,
  DataRow,
  SaveObject,
  ContextMenuItem,
} from "../../../core/models/offerEntryData";
import { CellSelection } from "./cellSelection";
import { GridHelper } from "./gridHelper";
import { MenuItem } from "../context-menu/menuItem";
import { ChartUpdateService } from "../../../core/services/chart-update.service";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "../../../core/services/message.service";
import { UserService } from "../../../core/services/user.service";
import { User } from "../../../core/models/user";

import { IAngularMyDpOptions, IMyDateModel } from "angular-mydatepicker";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { ModalOptions } from "ngx-bootstrap";
import { GridSetting } from "../../models/grid-setting";

import * as cloneDeep from "lodash/cloneDeep";
import { UtilsService } from "../../../core/services/utils.service";

import { OfferEntryDataService } from "../../../core/services/offer-entry-data.service";
import { Product } from "../../models/product";

@Component({
  selector: "app-offer-entry-grid",
  templateUrl: "./offer-entry-grid.component.html",
  styleUrls: ["./offer-entry-grid.component.css"],
  providers: [DatePipe],
})
export class OfferEntryGridComponent implements OnChanges, OnInit {
  debugMouseEvents = false; // toggle this to turn on console log of mouse cell clicks

  modalRef: BsModalRef; // ngx-bootstrap modal
  @ViewChild("uploadClearedOfferTmplt")
  uploadClearedOfferTmplt: TemplateRef<any>;
  @ViewChild("offerSummaryConfirmationTmplt")
  offerSummaryConfirmationTmplt: TemplateRef<any>;
  @ViewChild("deratingChangeConfirmationTmplt")
  deratingChangeConfirmationTmplt: TemplateRef<any>;
  @ViewChild("noClearedOfferConfirmationTmplt")
  noClearedOfferConfirmationTmplt: TemplateRef<any>;
  @ViewChild("rejectRegistrationConfirmationTmplt")
  rejectRegistrationConfirmationTmplt: TemplateRef<any>;
  @ViewChild("removeRegistrationConfirmationTmplt")
  removeRegistrationConfirmationTmplt: TemplateRef<any>;
  @ViewChild("updateProgramPriceTmplt")
  updateProgramPriceTmplt: TemplateRef<any>;
  @ViewChild("moveBidsTmplt") moveBidsTmplt: TemplateRef<any>;

  Dialog_ColumnContextMenu = 1;
  Dialog_CellContextMenu = 2;
  Dialog_SetValueDialog = 3;
  Dialog_AdjustValueDialog = 4;
  Dialog_GridRowNameContextMenu = 11;
  Dialog_GridTotalRowNameContextMenu = 12;
  Dialog_GridGroupRowNameContextMenu = 13;

  @Input() setting: GridSetting;
  @Input() currentDate;
  @Input() offerEntryDataInput: OfferEntryData;
  @Output() loadGridDataEvent: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() selectedDateChangedEvent: EventEmitter<String> =
    new EventEmitter<string>();
  @Output() saveCellDataEvent: EventEmitter<SaveObject> =
    new EventEmitter<SaveObject>();
  @Output() setBidPeriodsEvent: EventEmitter<SaveObject> =
    new EventEmitter<SaveObject>();
  @Output() displayContactListEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() sendNotificationEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() noClearedOfferEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirmClearedQuantityEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() createMarketOfferEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadClearedOfferEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() rejectRegistrationEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() manageGroupEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() addRegistrationEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeRegistrationEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() moveBidEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() cellActionEvent: EventEmitter<any> = new EventEmitter<any>();

  offerEntryData: OfferEntryData = null;
  selectedDate: any = null;
  selectedColumns: boolean[];
  previouslySelectedColumns: boolean[];
  cellSelection: CellSelection;
  isMouseDownOnColumn: boolean = false;
  sortAscending: boolean = true;
  firstSelectedColumn: number;
  lastSelectedColumn: number;
  lastClickWasRight: boolean = false;
  isMouseDownOnCell: boolean = false;
  showDialog: number = -1;
  contextmenuX = 0;
  contextmenuY = 0;
  this: EventTarget = null;
  ignoreNextBlur = false;
  currentColumn: number;
  sortColumn: number = -1;
  rightClickSelectedGridRow: GridRow = null;
  selectedStartDate: string = "";
  selectedEndDate = "";
  sortLabel: string;
  dateLabel: string;
  reloadLabel: string;
  econcapTooltip: string;
  reloadMessage: string;
  offerStatusLabel: string;

  deratingOldValue = 0.0;
  deratingNewValue = 0.0;
  deratingSelectedGridRow: GridRow = null;
  deratingAcceptButton: string = "";
  deratingCancelButton: string = "";
  deratingTitle: string = "";
  deratingText: string[] = [];
  deratingTarget: any;

  noClearedOfferAcceptButton: string = "";
  noClearedOfferCancelButton: string = "";
  noClearedOfferTitle: string = "";
  noClearedOfferText: string[] = [];

  sendNotificationAcceptButton: string = "";
  sendNotificationCancelButton: string = "";
  sendNotificationTitle: string = "";
  sendNotificationText: string[] = [];

  registrationConfirmationAcceptButton: string = "";
  registrationConfirmationCancelButton: string = "";
  rejectRegistrationTitle: string = "";
  rejectRegistrationConfirmationText: string[] = [];
  removeRegistrationTitle: string = "";
  removeRegistrationConfirmationText: string[] = [];

  cellContextMenuData: ContextMenuItem[];
  cellContextMenuItems: MenuItem[] = []; // The angular event calling order needs the menu's to be in variables rather than generated on the fly
  columnHeaderContextMenuData: ContextMenuItem[];
  columnContextMenuItems: MenuItem[] = [];
  gridRowNameContextMenuItems: MenuItem[] = [];
  gridTotalRowNameContextMenuItems: MenuItem[] = [];
  gridGroupRowNameContextMenuItems: MenuItem[] = [];

  users: User[] = [];

  myDatePickerOptions: IAngularMyDpOptions = {};

  currentMonth: number = new Date().getMonth() + 1;
  currentYear: number = new Date().getFullYear();
  dateTitlesObjects: any[] = [];
  markedDateObjects: any[] = [];
  dateLocale: String = "en";

  portfolioMoved: Boolean = true;

  constructor(
    private chartUpdateService: ChartUpdateService,
    private translate: TranslateService,
    private messageService: MessageService,
    private userService: UserService,
    private modalService: BsModalService,
    private utilsService: UtilsService,
    private el: ElementRef,
    private cdRef: ChangeDetectorRef,
    private datepipe: DatePipe,
    private offerEntryDataService: OfferEntryDataService
  ) {}

  ngOnInit() {
    if (!this.setting) {
      this.setting = new GridSetting();
    }

    window.addEventListener("mouseup", () => this.clearMouseDown());
    this.setLabels();

    this.userService.getEditing().subscribe((users) => {
      // listen for user editing data
      this.users = users;
    });

    setTimeout(() => {
      this.populatePreBiddingDates();
    }, 2000);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentDate) {
      const currentDate = changes.currentDate.currentValue;
      if (currentDate) {
        this.selectedDate = currentDate;
        this.updateDateSelectionWindow();
      }
    }
    if (changes.offerEntryDataInput) {
      this.utilsService.debugLog("Changes detected");
      const offerEntryData = changes.offerEntryDataInput.currentValue;
      if (offerEntryData) {
        this.mergeLoadedOfferEntryDataIntoGrid(offerEntryData);
      }
    }
  }

  onCalendarToggle = () => {
    setTimeout(() => {
      this.populatePreBiddingDates();
    }, 1000);
  };

  populatePreBiddingDates = () => {
    this.offerEntryDataService
      .getPreBiddingDates()
      .subscribe((preBiddingDates) => {
        if (preBiddingDates) {
          this.dateTitlesObjects = preBiddingDates.map((a) => ({
            year: new Date(a.date).getFullYear(),
            month: new Date(a.date).getMonth() + 1,
            day: new Date(a.date).getDate(),
            title: a.title,
          }));
          this.markedDateObjects = preBiddingDates.map((a) => ({
            year: new Date(a.date).getFullYear(),
            month: new Date(a.date).getMonth() + 1,
            day: new Date(a.date).getDate(),
          }));
          this.initMarkedDatesTitles();
          this.myDatePickerOptions = {
            markDates: [{ dates: this.markedDateObjects, color: "green" }],
          };
        }
      });
  };

  initMarkedDatesTitles = () => {
    const filteredDates = this.dateTitlesObjects.filter(
      (d) =>
        d.year === new Date().getFullYear() &&
        d.month === new Date().getMonth() + 1
    );
    this.updateDateCellTitles(filteredDates);
    const leftControls: any = document.querySelectorAll(
      ".headerbtn.ngxmdpicon.icon-ngxmydpleft.headerbtnenabled"
    );
    const rightControls: any = document.querySelectorAll(
      ".headerbtn.ngxmdpicon.icon-ngxmydpright.headerbtnenabled"
    );
    const leftMonthArrow = leftControls[0];
    const rightMonthArrow = rightControls[0];
    const leftYearArrow = leftControls[1];
    const rightYearArrow = rightControls[1];
    if (!leftMonthArrow) return;
    leftMonthArrow.onclick = () => this.setMonthAndYear.bind(this)(`leftMonth`);
    rightMonthArrow.onclick = () =>
      this.setMonthAndYear.bind(this)(`rightMonth`);
    leftYearArrow.onclick = () => this.setMonthAndYear.bind(this)(`leftYear`);
    rightYearArrow.onclick = () => this.setMonthAndYear.bind(this)(`rightYear`);
  };

  setMonthAndYear = (controlName) => {
    const controlMapper = {
      leftMonth: () =>
        (this.currentMonth =
          this.currentMonth === 1 ? 12 : this.currentMonth - 1),
      rightMonth: () =>
        (this.currentMonth =
          this.currentMonth === 12 ? 1 : this.currentMonth + 1),
      leftYear: () => (this.currentYear -= 1),
      rightYear: () => (this.currentYear += 1),
    };
    controlMapper[controlName]();
    this.updateDateCellTitles(
      this.dateTitlesObjects.filter(
        (d) => d.year === this.currentYear && d.month === this.currentMonth
      )
    );
  };

  updateDateCellTitles(filteredDates): void {
    const markedDates = document.querySelectorAll(
      'div[style*="background-color: green"]'
    );
    Array.prototype.slice
      .call(markedDates)
      .forEach((m, i) =>
        m.parentElement.setAttribute(
          "title",
          filteredDates[i] ? filteredDates[i].title : ""
        )
      );
  }

  setLabels() {
    this.sortLabel = this.translate.instant("default-text.sort");
    this.dateLabel = this.translate.instant("default-text.date");
    this.reloadLabel = this.translate.instant("default-text.reload");
    this.reloadMessage = this.translate.instant("error.grid_not_loaded");
    this.offerStatusLabel = this.translate.instant("default-text.offer-status");
    this.econcapTooltip = this.translate.instant(
      "default-text.econcap-tooltip"
    );
  }

  hasLoaded() {
    if (
      this.offerEntryData &&
      this.offerEntryData.sortedGridRows &&
      this.offerEntryData.sortedGridRows.length > 0
    ) {
      return true;
    }
    return false;
  }

  btn_reloadGridData() {
    this.loadGridDataEvent.emit(this.offerEntryData.loadedPortfolioID); // reload grid data
  }

  setDateFormatOptions() {
    this.dateLocale = JSON.parse(sessionStorage.getItem("currentUser")).locale;
    this.myDatePickerOptions = {
      // other options...
      dayLabels: {
        su: "Sun",
        mo: "Mon",
        tu: "Tue",
        we: "Wed",
        th: "Thu",
        fr: "Fri",
        sa: "Sat",
      },
      monthLabels: {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
      },
      dateFormat: "dd/mm/yyyy",
      firstDayOfWeek: "mo",
      sunHighlight: true,
    };

    // get more locales at https://github.com/kekeh/mydatepicker/blob/master/src/my-date-picker/services/my-date-picker.locale.service.ts
    if (this.dateLocale === "ko-kr") {
      this.myDatePickerOptions.dayLabels = {
        su: "일",
        mo: "월",
        tu: "화",
        we: "수",
        th: "목",
        fr: "금",
        sa: "토",
      };
      this.myDatePickerOptions.monthLabels = {
        1: "1월",
        2: "2월",
        3: "3월",
        4: "4월",
        5: "5월",
        6: "6월",
        7: "7월",
        8: "8월",
        9: "9월",
        10: "10월",
        11: "11월",
        12: "12월",
      };
      this.myDatePickerOptions.dateFormat = "yyyy.mm.dd";
      this.myDatePickerOptions["todayBtnTxt"] = "오늘";
      this.myDatePickerOptions.firstDayOfWeek = "su";
      this.myDatePickerOptions.sunHighlight = true;
    }
  }

  dateSelectionChanged(event: any) {
    if (event.date) {
      if (
        event.date.year > 2000 && // ignore blank dates
        !this.isDateSame(event, this.selectedDate)
      ) {
        this.selectedDate = event;
        this.updateDateSelectionWindow();
        const dateStr: String = this.getSelectedDateAsYYYYMMDD();
        this.selectedDateChangedEvent.emit(dateStr);
      }
    }
  }

  isDateSame(date1, date2) {
    if (!date1) {
      return false;
    }
    if (!date2) {
      return false;
    }
    if (!date1.date) {
      return false;
    }
    if (!date2.date) {
      return false;
    }
    if (date1.date.day !== date2.date.day) {
      return false;
    }
    if (date1.date.month !== date2.date.month) {
      return false;
    }
    if (date1.date.year !== date2.date.year) {
      return false;
    }
    return true;
  }

  getSelectedDateAsYYYYMMDD() {
    return (
      this.selectedDate.date.year +
      "-" +
      this.selectedDate.date.month.toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      }) +
      "-" +
      this.selectedDate.date.day.toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      })
    );
  }

  getSelectedProduct() {
    return this.offerEntryData ? this.offerEntryData.product : "";
  }

  updateDateSelectionWindow() {
    this.selectedStartDate = this.getSelectedDateAsYYYYMMDD() + "T00:00";
    this.selectedEndDate = this.getSelectedDateAsYYYYMMDD() + "T23:59";
  }

  setNoClearedOfferDialogText() {
    this.noClearedOfferAcceptButton = this.translate.instant(
      "default-text.continue"
    );
    this.noClearedOfferCancelButton = this.translate.instant(
      "default-text.cancel"
    );
    this.noClearedOfferTitle = this.translate.instant(
      "shared.no-cleared-offer-confirmation-dialog.title"
    );
    this.noClearedOfferText = [
      this.translate.instant(
        "shared.no-cleared-offer-confirmation-dialog.no-offer-received"
      ),
      this.translate.instant(
        "shared.no-cleared-offer-confirmation-dialog.zero-out"
      ),
      this.translate.instant("default-text.send-notifications"),
    ];
  }

  setRegistrationConfirmationDialogText(selectedRegistrationName: string) {
    this.registrationConfirmationAcceptButton =
      this.translate.instant("default-text.yes");
    this.registrationConfirmationCancelButton =
      this.translate.instant("default-text.no");
    this.rejectRegistrationConfirmationText = [
      this.translate.instant(
        "shared.reject-registration-confirmation-dialog.reject-bids"
      ) +
        " " +
        selectedRegistrationName,
      this.translate.instant("default-text.confirm-message"),
    ];
    this.rejectRegistrationTitle = this.translate.instant(
      "shared.reject-registration-confirmation-dialog.title"
    );
    this.removeRegistrationConfirmationText = [
      this.translate.instant(
        "shared.remove-registration-confirmation-dialog.remove-registration"
      ) +
        " " +
        selectedRegistrationName,
      this.translate.instant(
        "shared.remove-registration-confirmation-dialog.zero-out"
      ),
      this.translate.instant("default-text.confirm-message"),
    ];
    this.removeRegistrationTitle = this.translate.instant(
      "shared.remove-registration-confirmation-dialog.title"
    );
  }

  setNotificationConfirmationDialogText(mobile: string[], message: string) {
    this.sendNotificationAcceptButton = this.translate.instant(
      "default-text.continue"
    );
    this.sendNotificationCancelButton = this.translate.instant(
      "default-text.cancel"
    );
    this.sendNotificationTitle = this.translate.instant(
      "shared.offer-entry-grid.send-notification"
    );
    const recipients: string =
      this.translate.instant("default-text.recipient") +
      "<br>" +
      mobile.join("<br>");
    this.sendNotificationText = [recipients, message];
  }

  getCellContextMenu(hasClipboardData: boolean): MenuItem[] {
    return null;
    /*return [
            { func: this.setValue, isSeparator: false, text: this.translate.instant('default-text.set-value') as string, isEnabled: editable },
            { func: this.adjustValue, isSeparator: false, text: this.translate.instant('default-text.adjust-value') as string, isEnabled: editable },
            { func: null, isSeparator: true, text: '', isEnabled: false },
            { func: this.copySelection, isSeparator: false, text: this.translate.instant('default-text.copy') as string, isEnabled: true },
            { func: this.pasteIntoGrid, isSeparator: false, text: this.translate.instant('default-text.paste') as string, isEnabled: (editable && hasClipboardData) }
        ];*/
  }

  setCellContextMenuItems() {
    this.cellContextMenuItems = []; //this.getCellContextMenu(this.cellSelection.isEditable(), this.cellSelection.hasClipboardData());
    this.getContextMenuItems(
      this.cellContextMenuData,
      "grid_cell",
      this.cellContextMenuItems
    );
    this.cellContextMenuItems.push({
      func: this.copySelection,
      isSeparator: false,
      text: this.translate.instant("default-text.copy") as string,
      isEnabled: true,
    });
    this.cellContextMenuItems.push({
      func: this.pasteIntoGrid,
      isSeparator: false,
      text: this.translate.instant("default-text.paste") as string,
      isEnabled:
        this.cellSelection.isEditable() &&
        this.cellSelection.hasClipboardData(),
    });
  }

  setColumnContextMenuItems() {
    this.columnContextMenuItems = [];
    //if (this.isPortfolioSelected()) {
    //    this.columnContextMenuItems.push({ func: this.setBidPeriods, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.set-bid-periods') as string, isEnabled: this.selectedColumns.indexOf(true) >= 0 });
    //}
    this.getContextMenuItems(
      this.columnHeaderContextMenuData,
      "column_header",
      this.columnContextMenuItems
    );
    const sortable =
      this.offerEntryData.selectedSort != null &&
      this.offerEntryData.selectedSort.name !== this.offerStatusLabel;
    this.columnContextMenuItems.push({
      func: this.sortSingleColumn,
      isSeparator: false,
      text: this.translate.instant("shared.offer-entry-grid.sort-single"),
      isEnabled: sortable,
    });
    this.columnContextMenuItems.push({
      func: this.sortAllColumns,
      isSeparator: false,
      text: this.translate.instant("shared.offer-entry-grid.sort-all"),
      isEnabled: sortable,
    });
  }

  setGridRowNameContextMenuItems(loadedOfferEntryData: OfferEntryData) {
    this.gridRowNameContextMenuItems = [];
    let cmType = this.isPortfolioSelected() ? "registration" : "portfolio";
    if (!this.isPortfolioSelected()) {
      // no portfolio selected, so grid rows are each portfolios //this.offerEntryData.loadedPortfolioID.length === 0 || this.offerEntryData.loadedPortfolioID === '-1') {
      this.gridRowNameContextMenuItems.push({
        func: this.viewPortfolioDetails,
        isSeparator: false,
        text: this.translate.instant(
          "shared.offer-entry-grid.view-portfolio-details"
        ) as string,
        isEnabled: true,
      });
      this.gridRowNameContextMenuItems.push({
        func: null,
        isSeparator: true,
        text: "",
        isEnabled: false,
      });
    }
    this.getContextMenuItems(
      loadedOfferEntryData.rowHeaderContextMenu,
      cmType,
      this.gridRowNameContextMenuItems
    );
    /*
            this.gridRowNameContextMenuItems.push({ func: this.createMarketOffer_EDR, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.create-market-offer') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.loadClearedOffer, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.load-cleared-offer') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.confirmClearedQuantity, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.confirm-cleared-quantity') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.noClearedOffer, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.no-cleared-offer') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: null, isSeparator: true, text: '', isEnabled: false });
            this.gridRowNameContextMenuItems.push({ func: this.addRegistrationToPortfolio, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.add-registration') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.manageGroup, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.manage-group') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.updateProgramPrice, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.update-program-price') as string, isEnabled: true });
        } else {  // portfolio is selected, so grid rows are registrations/groups
            this.gridRowNameContextMenuItems.push({ func: this.displayContactList, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.display-contact-list') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.sendNotification, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.send-notification') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: null, isSeparator: true, text: '', isEnabled: false });
            this.gridRowNameContextMenuItems.push({ func: this.confirmClearedQuantity, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.confirm-cleared-quantity') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: this.rejectRegistration, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.reject-registration') as string, isEnabled: true });
            this.gridRowNameContextMenuItems.push({ func: null, isSeparator: true, text: '', isEnabled: false });
            this.gridRowNameContextMenuItems.push({ func: this.removeRegistration, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.remove-registration') as string, isEnabled: true });
        }*/
  }

  setGridGroupRowNameContextMenuItems(loadedOfferEntryData: OfferEntryData) {
    this.gridGroupRowNameContextMenuItems = [];
    if (this.isPortfolioSelected()) {
      // portfolio is selected, so total row is portfolio
      this.getContextMenuItems(
        loadedOfferEntryData.rowHeaderContextMenu,
        "group",
        this.gridGroupRowNameContextMenuItems
      );
    }
    /*
        if (this.isPortfolioSelected()) {  // portfolio is selected, so total row is portfolio
            this.gridGroupRowNameContextMenuItems.push({ func: this.displayContactList, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.display-contact-list') as string, isEnabled: true });
            this.gridGroupRowNameContextMenuItems.push({ func: this.sendNotification, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.send-notification') as string, isEnabled: true });
            this.gridGroupRowNameContextMenuItems.push({ func: null, isSeparator: true, text: '', isEnabled: false });
            this.gridGroupRowNameContextMenuItems.push({ func: this.confirmClearedQuantity, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.confirm-cleared-quantity') as string, isEnabled: true });
            this.gridGroupRowNameContextMenuItems.push({ func: this.rejectRegistration, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.reject-registration') as string, isEnabled: true });
            this.gridGroupRowNameContextMenuItems.push({ func: null, isSeparator: true, text: '', isEnabled: false });
            // this.gridGroupRowNameContextMenuItems.push({ func: this.addRegistrationToGroup, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.add-registration') as string, isEnabled: true });
            this.gridGroupRowNameContextMenuItems.push({ func: this.removeRegistration, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.remove-registration') as string, isEnabled: true });
        }*/
  }

  setGridTotalRowNameContextMenuItems(loadedOfferEntryData: OfferEntryData) {
    this.gridTotalRowNameContextMenuItems = [];
    let cmType = this.isPortfolioSelected() ? "portfolio" : "total";
    if (this.isPortfolioSelected()) {
      // portfolio is selected, so total row is portfolio
      this.gridTotalRowNameContextMenuItems.push({
        func: this.viewAllPortfolios,
        isSeparator: false,
        text: this.translate.instant(
          "shared.offer-entry-grid.view-all-portfolios"
        ) as string,
        isEnabled: true,
      });
      this.gridTotalRowNameContextMenuItems.push({
        func: null,
        isSeparator: true,
        text: "",
        isEnabled: false,
      });
    }
    this.getContextMenuItems(
      loadedOfferEntryData.rowHeaderContextMenu,
      cmType,
      this.gridTotalRowNameContextMenuItems
    );
    /*
            this.gridTotalRowNameContextMenuItems.push({ func: this.createMarketOffer_EDR, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.create-market-offer') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: this.loadClearedOffer, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.load-cleared-offer') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: this.confirmClearedQuantity, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.confirm-cleared-quantity') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: this.noClearedOffer, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.no-cleared-offer') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: null, isSeparator: true, text: '', isEnabled: false });
            this.gridTotalRowNameContextMenuItems.push({ func: this.addRegistrationToPortfolio, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.add-registration') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: this.manageGroup, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.manage-group') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: this.updateProgramPrice, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.update-program-price') as string, isEnabled: true });
        } else {  // no portfolio selected, so each row in grid is a portfolio, and this line is the overall Total
            this.gridTotalRowNameContextMenuItems.push({ func: this.manageGroup, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.manage-group') as string, isEnabled: true });
            this.gridTotalRowNameContextMenuItems.push({ func: this.updateProgramPrice, isSeparator: false, text: this.translate.instant('shared.offer-entry-grid.update-program-price') as string, isEnabled: true });
        }*/
  }

  private getContextMenuItems(
    contextMenuData: ContextMenuItem[],
    typeKey: string,
    itemsCollection: MenuItem[]
  ) {
    if (contextMenuData === null || itemsCollection === null) {
      return;
    }
    let isPortfolioSelected: boolean = this.isPortfolioSelected();
    for (const cmItem of contextMenuData) {
      if (cmItem.typeKey === typeKey) {
        if (
          (isPortfolioSelected && cmItem.includeForDetailedView) ||
          (!isPortfolioSelected && cmItem.includeForAggregatedView)
        ) {
          let newItem: MenuItem = {
            func: this.getContextMenuFunction(cmItem.functionKey),
            isSeparator: cmItem.isSeparator,
            text: cmItem.caption,
            isEnabled: this.getIsFunctionEnabled(
              cmItem.functionKey,
              cmItem.isSeparator
            ),
          };
          itemsCollection.push(newItem);
        }
      }
    }
  }

  private getIsFunctionEnabled(
    functionKey: string,
    isSeparator: boolean
  ): boolean {
    if (functionKey) {
      switch (functionKey) {
        case "set_bid_periods": {
          return this.selectedColumns.indexOf(true) >= 0;
        }
        case "set_values_default":
        case "adjust_values_default": {
          return this.cellSelection.isEditable();
        }
        default: {
          return !isSeparator;
        }
      }
    }
  }

  private getContextMenuFunction(functionKey: string): Function {
    if (functionKey) {
      switch (functionKey) {
        case "manage_group": {
          return this.manageGroup;
        }
        case "update_program_price": {
          return this.updateProgramPrice;
        }
        case "create_market_offer_edr": {
          return this.createMarketOffer_EDR;
        }
        case "load_cleared_offer": {
          return this.loadClearedOffer;
        }
        case "confirm_cleared_quantity": {
          return this.confirmClearedQuantity;
        }
        case "no_cleared_offer": {
          return this.noClearedOffer;
        }
        case "add_reg_to_portfolio": {
          return this.addRegistrationToPortfolio;
        }
        case "display_contact_list": {
          return this.displayContactList;
        }
        case "send_notification": {
          return this.sendNotification;
        }
        case "reject_registration": {
          return this.rejectRegistration;
        }
        case "remove_registration": {
          return this.removeRegistration;
        }
        case "set_bid_periods": {
          return this.setBidPeriods;
        }
        case "set_values_default": {
          return this.setValue;
        }
        case "adjust_values_default": {
          return this.adjustValue;
        }
        case "move_bids": {
          return this.moveBids;
        }
        default: {
          return null;
        }
      }
    }
    return null;
  }

  private isPortfolioSelected(): boolean {
    return (
      this.offerEntryData.loadedPortfolioID.length > 0 &&
      this.offerEntryData.loadedPortfolioID !== "-1"
    );
  }

  closeAllOpenDialogs(expected: boolean) {
    this.showDialog = -1;
  }

  hasData(dataRow: DataRow, i: number): boolean {
    if (dataRow.roundedDataValues) {
      return dataRow.roundedDataValues.length > i;
    }
    return false;
  }

  receiveCellContextMenuEvent(func: Function) {
    this.closeAllOpenDialogs(true);
    func.call(this);
  }

  receiveColumnHeaderContextMenuEvent(func: Function) {
    this.closeAllOpenDialogs(true);
    func.call(this);
  }

  receiveGridRowNameContextMenuEvent(func: Function) {
    this.closeAllOpenDialogs(true);
    func.call(this);
  }

  receiveGridTotalRowNameContextMenuEvent(func: Function) {
    this.closeAllOpenDialogs(true);
    func.call(this);
  }

  receiveGridGroupRowNameContextMenuEvent(func: Function) {
    this.closeAllOpenDialogs(true);
    func.call(this);
  }

  setValue() {
    this.showDialog = this.Dialog_SetValueDialog;
  }

  adjustValue() {
    this.showDialog = this.Dialog_AdjustValueDialog;
  }

  sortSingleColumn() {
    this.sortColumn = this.currentColumn;
    this.offerEntryData.selectedSort.function(
      this.offerEntryData,
      this.offerEntryData.selectedSort.dataVal,
      this.sortColumn,
      this.sortAscending
    );
  }

  sortAllColumns() {
    this.sortColumn = -1;
    this.offerEntryData.selectedSort.function(
      this.offerEntryData,
      this.offerEntryData.selectedSort.dataVal,
      this.sortColumn,
      this.sortAscending
    );
  }

  // addRegistrationToGroup() {
  //     this.equipmentService.getEquipmentsForGroup(
  //         this.offerEntryData.loadedPortfolioID, this.selectedStartDate, this.selectedEndDate
  //     ).subscribe((data) => {
  //         if (data) {
  //             this.addRegistrationData = data;
  //             this.addRegistration();
  //         }
  //     });
  // }

  addRegistrationToPortfolio() {
    const portfolioId: string =
      this.offerEntryData.loadedPortfolioID === "" ||
      this.offerEntryData.loadedPortfolioID === "-1"
        ? this.rightClickSelectedGridRow.id
        : this.offerEntryData.loadedPortfolioID;
    const addRegistrationData: any = {
      loadedPortfolioId: this.offerEntryData.loadedPortfolioID,
      portfolioId: portfolioId,
      itemAggregationLevel: this.rightClickSelectedGridRow.aggregationlevel,
      itemId: this.rightClickSelectedGridRow.id,
      startDate: this.selectedStartDate,
      endDate: this.selectedEndDate,
      product: this.offerEntryData.product,
    };
    this.addRegistrationEvent.emit(addRegistrationData);
  }

  // addRegistration() {
  //     this.openModal(this.addRegTmplt);
  // }

  manageGroup() {
    this.manageGroupEvent.emit();
  }

  confirmClearedQuantity() {
    this.saveStatus("Confirm");
  }

  saveStatus(command: string): void {
    const portfolioId =
      this.offerEntryData.loadedPortfolioID.length > 0 &&
      this.offerEntryData.loadedPortfolioID !== "-1"
        ? this.offerEntryData.loadedPortfolioID
        : this.rightClickSelectedGridRow.id;
    const selectedItemId: string = this.rightClickSelectedGridRow.id;
    const selectedItemLevel: string =
      this.rightClickSelectedGridRow.aggregationlevel;
    const startDate: string = this.selectedStartDate;
    const endDate: string = this.selectedEndDate;

    const confirmClearedQuantityData: any = {
      command: command,
      portfolioId: portfolioId,
      itemId: selectedItemId,
      itemAggregationLevel: selectedItemLevel,
      startDate: startDate,
      endDate: endDate,
      product: this.offerEntryData.product,
    };

    this.confirmClearedQuantityEvent.emit(confirmClearedQuantityData);
  }

  isColumnOffered(column: number): boolean {
    if (this.offerEntryData.isOfferedToMarket.length < column) {
      return false;
    } else {
      return this.offerEntryData.isOfferedToMarket[column];
    }
  }

  createMarketOffer_EDR() {
    const intervals: number[] = [];
    for (let i = 0; i < this.offerEntryData.columnHeaders.length; i++) {
      if (this.selectedColumns[i]) {
        intervals.push(this.offerEntryData.intervalIds[i]);
      }
    }
    if (intervals.length === 0) {
      // if they haven't selected any columns, fall back to what is already offered
      for (let i = 0; i < this.offerEntryData.columnHeaders.length; i++) {
        if (this.isColumnOffered(i)) {
          intervals.push(this.offerEntryData.intervalIds[i]);
        }
      }
    }

    const id: string = this.rightClickSelectedGridRow.id;
    const date: string = this.messageService.getFormatedDate(this.selectedDate);

    const createMarketOfferData: any = {
      portfolioId: id,
      intervals: intervals,
      date: date,
      product: this.offerEntryData.product,
    };
    this.createMarketOfferEvent.emit(createMarketOfferData);
  }

  loadClearedOffer() {
    this.openModal(this.uploadClearedOfferTmplt);
  }

  updateProgramPrice() {
    this.openModal(this.updateProgramPriceTmplt);
  }

  noClearedOffer() {
    this.setNoClearedOfferDialogText();
    this.openModal(this.noClearedOfferConfirmationTmplt);
  }

  rejectRegistration() {
    this.setRegistrationConfirmationDialogText(
      this.rightClickSelectedGridRow.name
    );
    this.openModal(this.rejectRegistrationConfirmationTmplt);
  }

  removeRegistration() {
    this.setRegistrationConfirmationDialogText(
      this.rightClickSelectedGridRow.name
    );
    this.openModal(this.removeRegistrationConfirmationTmplt);
  }

  displayContactList() {
    const sendContactData: any = {
      offerEntryData: this.offerEntryData,
      selectedItem: this.rightClickSelectedGridRow,
    };
    this.displayContactListEvent.emit(sendContactData);
  }

  sendNotification() {
    const sendNotificationData: any = {
      offerEntryData: this.offerEntryData,
      selectedItem: this.rightClickSelectedGridRow,
    };
    this.sendNotificationEvent.emit(sendNotificationData);
  }

  setBidPeriods() {
    const intervals: number[] = [];
    for (let i = 0; i < this.offerEntryData.columnHeaders.length; i++) {
      if (this.selectedColumns[i]) {
        intervals.push(this.offerEntryData.intervalIds[i]);
      }
    }
    const id: string = this.offerEntryData.loadedPortfolioID;
    const date: string = this.messageService.getFormatedDate(this.selectedDate);
    const setBidPeriodsData: any = {
      portfolioId: id,
      intervals: intervals,
      date: date,
      product: this.offerEntryData.product,
    };
    this.setBidPeriodsEvent.emit(setBidPeriodsData);
  }

  viewPortfolioDetails() {
    this.loadGridDataEvent.emit(this.rightClickSelectedGridRow.id); // reload grid data
    this.portfolioMoved = true;
  }

  viewAllPortfolios() {
    this.loadGridDataEvent.emit(""); // divert back to home level
  }

  moveBids() {
    this.openModal(this.moveBidsTmplt);
  }

  openModal(template: TemplateRef<any>, classList?: string) {
    const config: ModalOptions = new ModalOptions();
    if (classList) {
      config.class = classList;
    }
    this.modalRef = this.modalService.show(template, config);
  }

  onSortChange($event) {
    this.updateSortView();
  }

  updateSortView() {
    this.offerEntryData.selectedSort.function(
      this.offerEntryData,
      this.offerEntryData.selectedSort.dataVal,
      this.sortColumn,
      this.sortAscending
    );
    this.setColumnContextMenuItems();
    this.chartUpdateService.TriggerAnotherUpdate(
      "SortChanged," +
        this.offerEntryData.selectedSort.dataVal +
        "," +
        this.sortColumn +
        "," +
        (this.sortAscending ? "TRUE" : "FALSE")
    );
  }

  toggleSort() {
    this.sortAscending = !this.sortAscending;
    this.updateSortView();
  }

  receiveSetValueCloseEvent($event) {
    this.closeAllOpenDialogs(true);
  }

  receiveSetValueEvent($event: number) {
    this.setSelection($event);
    this.closeAllOpenDialogs(true);
  }

  receiveAdjustValueCloseEvent($event) {
    this.closeAllOpenDialogs(true);
  }

  receiveAdjustValueEvent($event: number) {
    this.adjustSelection($event);
    this.closeAllOpenDialogs(true);
  }

  receiveNoClearedOfferConfirmationButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Accept") {
      let portfolioId: string = "";
      let aggregationlevel: string = "";
      if (
        this.offerEntryData.loadedPortfolioID.length === 0 ||
        this.offerEntryData.loadedPortfolioID === "-1"
      ) {
        portfolioId = this.rightClickSelectedGridRow.id;
        aggregationlevel = this.rightClickSelectedGridRow.aggregationlevel;
      } else {
        portfolioId = this.offerEntryData.loadedPortfolioID;
        aggregationlevel = "PORTFOLIO";
      }

      const noClearedData: any = {
        portfolioId: portfolioId,
        aggregationlevel: aggregationlevel,
        offerEntryData: this.offerEntryData,
        product: this.offerEntryData.product,
      };

      this.noClearedOfferEvent.emit(noClearedData);
    } else if ($event === "Cancel") {
      // todo handle cancel
    }
  }

  receiveClearedOfferDialogButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Upload") {
      this.openModal(this.offerSummaryConfirmationTmplt, "modal-lg");
    } else if ($event === "Cancel") {
      // do nothing
    }
  }

  receiveUpdateProgramPriceDialogButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Update") {
      // Handled
      //TODO? Send notification to other users
    } else if ($event === "Cancel") {
      // do nothing
    }
  }

  receiveOfferSummaryConfirmationButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Confirm") {
      const loadClearedOfferData: any = {
        date: this.selectedStartDate.slice(0, -6),
        portfolioId: this.rightClickSelectedGridRow.id,
      };
      this.loadClearedOfferEvent.emit(loadClearedOfferData);
    } else if ($event === "Cancel") {
      // do nothing
    }
  }

  receiveMoveBidsDialogButtonEvent($event: Product) {
    this.modalRef.hide();
    if ($event !== null) {
      const portfolioId: string =
        this.offerEntryData.loadedPortfolioID === "" ||
        this.offerEntryData.loadedPortfolioID === "-1"
          ? this.rightClickSelectedGridRow.id
          : this.offerEntryData.loadedPortfolioID;
      const moveBidData: any = {
        loadedPortfolioId: portfolioId,
        itemAggregationLevel: this.rightClickSelectedGridRow.aggregationlevel,
        itemId: this.rightClickSelectedGridRow.id,
        itemName: this.rightClickSelectedGridRow.name,
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        product: this.offerEntryData.product,
        destProductId: $event.productId,
      };
      this.utilsService.debugLog(moveBidData);
      this.moveBidEvent.emit(moveBidData);

      /*const loadOfferData: any = {
                date: this.selectedStartDate.slice(0, -6),
                portfolioId: this.rightClickSelectedGridRow.id
            };
            this.loadClearedOfferEvent.emit(loadOfferData);*/
    } else {
      // do nothing
    }
  }

  onderatingChange($event, gridRow: GridRow): boolean {
    if (gridRow.hasManualUpdates.indexOf(true) >= 0) {
      this.deratingOldValue = gridRow.deratingFactor;
      this.deratingTarget = $event.target;
      this.deratingNewValue = $event.target.value;
      this.deratingSelectedGridRow = gridRow;
      this.contextmenuX = $event.target.offsetLeft;
      this.contextmenuY = $event.target.offsetTop;
      this.deratingAcceptButton = this.translate.instant(
        "default-text.continue"
      );
      this.deratingCancelButton = this.translate.instant("default-text.cancel");
      this.deratingTitle = this.translate.instant(
        "shared.derating-change-confirmation-dialog.title"
      );
      this.deratingText = [
        this.translate.instant(
          "shared.derating-change-confirmation-dialog.changing-from"
        ) +
          " " +
          this.deratingOldValue +
          " " +
          this.translate.instant(
            "shared.derating-change-confirmation-dialog.to"
          ) +
          " " +
          this.deratingNewValue,
        this.translate.instant(
          "shared.derating-change-confirmation-dialog.overwrite-warning"
        ),
      ];
      this.deratingTarget.value = this.deratingOldValue; // set it back temporarily - workaround for gui not updating with original value (see https://github.com/angular/angular/issues/12316)
      this.openModal(this.deratingChangeConfirmationTmplt);
    } else {
      // gridRow.deratingFactor = $event.target.value;
      this.sendSaveDeratingFactorMessage(gridRow, $event.target.value);
      this.cellActionEvent.emit({
        action: "EDITED",
        gridRow: gridRow,
        rowIdx: -1,
        colIdxs: [-1],
      });
      // this.messageHandler('EDITED', gridRow, -1, [-1]);
    }

    return false;
  }

  receiveDeratingChangeConfirmationButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Accept") {
      // this.deratingSelectedGridRow.deratingFactor = this.deratingNewValue;
      // this.deratingTarget.value = this.deratingNewValue;
      this.sendSaveDeratingFactorMessage(
        this.deratingSelectedGridRow,
        this.deratingNewValue
      );
      this.cellActionEvent.emit({
        action: "EDITED",
        gridRow: this.deratingSelectedGridRow,
        rowIdx: -1,
        colIdxs: [-1],
      });
      // this.messageHandler('EDITED', this.deratingSelectedGridRow, -1, [-1]);
    } else if ($event === "Cancel") {
    }
  }

  receiveRejectRegistrationConfirmationButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Accept") {
      const rejectRegistrationData: any = {
        loadedPortfolioId: this.offerEntryData.loadedPortfolioID,
        itemAggregationLevel: this.rightClickSelectedGridRow.aggregationlevel,
        itemId: this.rightClickSelectedGridRow.id,
        itemName: this.rightClickSelectedGridRow.name,
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        product: this.offerEntryData.product,
      };
      this.rejectRegistrationEvent.emit(rejectRegistrationData);
    } else if ($event === "Cancel") {
      // do nothing
    }
  }

  receiveRemoveRegistrationConfirmationButtonEvent($event: string) {
    this.modalRef.hide();
    if ($event === "Accept") {
      // todo handle yes
      const removeRegistrationData: any = {
        loadedPortfolioId: this.offerEntryData.loadedPortfolioID,
        itemAggregationLevel: this.rightClickSelectedGridRow.aggregationlevel,
        itemId: this.rightClickSelectedGridRow.id,
        itemName: this.rightClickSelectedGridRow.name,
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        product: this.offerEntryData.product,
      };
      this.removeRegistrationEvent.emit(removeRegistrationData);
    } else if ($event === "Cancel") {
      // todo handle no
      // this.utilsService.debugLog('Cancel removing the equipment');
    }
  }

  clearSelections(): void {
    this.cellSelection.clearSelection();
    this.selectedColumns.forEach((selectedColumn, i) => {
      this.selectedColumns[i] = false;
    });
  }

  copySelection(): boolean {
    this.cellSelection.copySelection(this.offerEntryData);
    this.setCellContextMenuItems();
    return false;
  }

  pasteIntoGrid(): boolean {
    this.cellSelection.pasteIntoGrid(this.offerEntryData);

    this.sendSaveChangesMessage();
    this.cellSelection.clearEdits();
    this.chartUpdateService.TriggerAnotherUpdate("cellChange");

    // this.notifyMessageServiceOfEdit();

    return false;
  }

  getIsFocused(gridRow: GridRow, dataRow: number, column: number) {
    if (
      this.cellSelection.isCellSelected(gridRow.id, dataRow, column) &&
      column == this.cellSelection.firstSelectedCellColumn
    ) {
      return true;
    }

    return false;
  }

  getIsEditable(gridRow: GridRow, dataRow: number, column: number) {
    if (!gridRow.dataRows[dataRow].isEditable) {
      return false;
    }
    if (
      this.offerEntryData.columnEditable.length > column &&
      !this.offerEntryData.columnEditable[column]
    ) {
      return false;
    }
    return true;
  }

  enterPressed(event): boolean {
    if (this.cellSelection.isEdited()) {
      this.sendSaveChangesMessage();
      this.cellSelection.clearEdits();
      this.chartUpdateService.TriggerAnotherUpdate("cellChange");
      // this.notifyMessageServiceOfEdit();
    }

    // move across to next cell
    let newColumn = this.cellSelection.firstColumn + 1;
    if (newColumn >= this.offerEntryData.columnHeaders.length) {
      newColumn = 0;
    }
    this.cellSelection.selectCell(
      this.offerEntryData,
      this.cellSelection.firstSelectedCellGridRowId,
      this.cellSelection.subrow,
      newColumn,
      this.cellSelection.canEdit
    );

    return false;
  }

  sendSaveDeratingFactorMessage(gridRow: GridRow, newValue: number) {
    if (this.setting.sendSaveChangesMessage) {
      const saveObject: SaveObject = {
        level: gridRow.aggregationlevel,
        id: gridRow.id,
        dataType: "DeratingFactor",
        date: this.messageService.getFormatedDate(this.selectedDate),
        intervals: [],
        values: [],
        product: this.offerEntryData.product,
      };
      saveObject.values.push(newValue);
      this.saveCellDataEvent.emit(saveObject);
      gridRow.deratingFactorEditField = null;
    }
  }

  sendSaveChangesMessage() {
    if (this.setting.sendSaveChangesMessage) {
      const selection = this.cellSelection.getSelection(this.offerEntryData);
      const gridRow: GridRow = selection.gridRow;
      const row: number = selection.row;
      const cols: number[] = selection.cols;

      const saveObject: SaveObject = {
        level: gridRow.aggregationlevel,
        id: gridRow.id,
        dataType: gridRow.dataRows[row].metaDataKey,
        date: this.messageService.getFormatedDate(this.selectedDate),
        intervals: cols.map((col) => this.offerEntryData.intervalIds[col]),
        values: selection.values,
        product: this.offerEntryData.product,
      };
      this.saveCellDataEvent.emit(saveObject);
    }
  }

  getTabIndex(gridRow: number, dataRow: number, column: number) {
    return (
      100 +
      gridRow * (this.offerEntryData.columnHeaders.length * 5) +
      dataRow * this.offerEntryData.columnHeaders.length +
      column
    );
  }

  cellToolTip(dataRow: DataRow, column: number) {
    if (dataRow.cellTooltip.length > column) {
      return dataRow.cellTooltip[column];
    } else {
      return "";
    }
  }

  setSelection(newValue: number) {
    this.cellSelection.setSelection(this.offerEntryData, newValue);
    this.sendSaveChangesMessage();
    this.cellSelection.clearEdits();
    this.chartUpdateService.TriggerAnotherUpdate("cellChange");

    // this.notifyMessageServiceOfEdit();
  }

  adjustSelection(amount: number) {
    this.cellSelection.adjustSelection(this.offerEntryData, amount);
    this.sendSaveChangesMessage();
    this.cellSelection.clearEdits();
    this.chartUpdateService.TriggerAnotherUpdate("cellChange");

    // this.notifyMessageServiceOfEdit();
  }

  datesAreEqual(date1: Date, date2: Date): boolean {
    if (date1 && date2) {
      if (date1.toDateString() === date2.toDateString()) {
        return true;
      } else {
        return false;
      }
    } else if (!date1 && !date2) {
      return true;
    } else {
      return false;
    }
  }

  mergeLoadedOfferEntryDataIntoGrid(loadedOfferEntryData: OfferEntryData) {
    let gridViewCompletelyChanged = false;
    if (this.offerEntryData) {
      if (
        loadedOfferEntryData.loadedPortfolioID !==
        this.offerEntryData.loadedPortfolioID
      ) {
        this.utilsService.debugLog("changed portfolio");
        gridViewCompletelyChanged = true;
      } else if (
        !this.datesAreEqual(
          loadedOfferEntryData.startTime,
          this.offerEntryData.startTime
        )
      ) {
        this.utilsService.debugLog("changed starttime");
        gridViewCompletelyChanged = true;
      } else if (
        !this.datesAreEqual(
          loadedOfferEntryData.endTime,
          this.offerEntryData.endTime
        )
      ) {
        this.utilsService.debugLog("changed endtime");
        gridViewCompletelyChanged = true;
      } else if (
        loadedOfferEntryData.gridRows.length !==
        this.offerEntryData.gridRows.length
      ) {
        this.utilsService.debugLog("changed data length");
        gridViewCompletelyChanged = true;
      } else if (loadedOfferEntryData.level !== this.offerEntryData.level) {
        this.utilsService.debugLog("changed level");
        gridViewCompletelyChanged = true;
      }
    } else {
      gridViewCompletelyChanged = true;
    }

    if (gridViewCompletelyChanged) {
      this.utilsService.debugLog("Reload Grid");
      // this.offerEntryData = cloneDeep(loadedOfferEntryData);
      this.offerEntryData = loadedOfferEntryData;
      this.cellSelection = new CellSelection();
      GridHelper.initialiseSort(this.offerEntryData);
      this.initialiseColumnSelection();

      if (this.offerEntryData.gridRows.length > 0 && this.portfolioMoved) {
        this.portfolioMoved = false;
      }

      this.clearSelections();
      this.cellContextMenuData = loadedOfferEntryData.cellContextMenu;
      this.columnHeaderContextMenuData =
        loadedOfferEntryData.columnHeaderContextMenu;
      this.setCellContextMenuItems();
      this.setColumnContextMenuItems();
      this.setGridRowNameContextMenuItems(loadedOfferEntryData);
      this.setGridTotalRowNameContextMenuItems(loadedOfferEntryData);
      this.setGridGroupRowNameContextMenuItems(loadedOfferEntryData);
      this.setNoClearedOfferDialogText();
      this.setRegistrationConfirmationDialogText("");
      this.setDateFormatOptions();
    } else {
      if (this.offerEntryData.product !== loadedOfferEntryData.product) {
        this.offerEntryData.product = loadedOfferEntryData.product;
      }
      this.utilsService.debugLog("Merge refreshed data into grid");
      // we copy data in a value at a time so that existing references (like sort etc) work ok.
      // this.utilsService.debugLog('loading gridrows - ' + this.offerEntryData.gridRows.length);
      if (!this.offerEntryData.isOfferedToMarket) {
        this.offerEntryData.isOfferedToMarket =
          loadedOfferEntryData.isOfferedToMarket;
      } else if (
        this.offerEntryData.isOfferedToMarket.length <
        loadedOfferEntryData.isOfferedToMarket.length
      ) {
        this.offerEntryData.isOfferedToMarket =
          loadedOfferEntryData.isOfferedToMarket;
      } else {
        for (let c = 0; c < this.offerEntryData.columnHeaders.length; c++) {
          this.offerEntryData.isOfferedToMarket[c] =
            loadedOfferEntryData.isOfferedToMarket[c];
        }
      }
      for (let g = 0; g < this.offerEntryData.gridRows.length; g++) {
        this.offerEntryData.gridRows[g].deratingFactor =
          loadedOfferEntryData.gridRows[g].deratingFactor;
        this.offerEntryData.gridRows[g].deratingFactorEditField =
          loadedOfferEntryData.gridRows[g].deratingFactorEditField;
        this.offerEntryData.gridRows[g].hasAlert =
          loadedOfferEntryData.gridRows[g].hasAlert;
        this.offerEntryData.gridRows[g].alertColor =
          loadedOfferEntryData.gridRows[g].alertColor;
        this.offerEntryData.gridRows[g].alertTooltip =
          loadedOfferEntryData.gridRows[g].alertTooltip;
        this.offerEntryData.gridRows[g].hasInfo =
          loadedOfferEntryData.gridRows[g].hasInfo;
        this.offerEntryData.gridRows[g].infoTooltip =
          loadedOfferEntryData.gridRows[g].infoTooltip;
        this.offerEntryData.gridRows[g].clearedIntervals =
          loadedOfferEntryData.gridRows[g].clearedIntervals;
        // this.utilsService.debugLog('loading column headers - ' + this.offerEntryData.columnHeaders.length);
        for (let c = 0; c < this.offerEntryData.columnHeaders.length; c++) {
          this.offerEntryData.gridRows[g].hasManualUpdates[c] =
            loadedOfferEntryData.gridRows[g].hasManualUpdates[c];
        }
        // this.utilsService.debugLog('loading datarows - ' + this.offerEntryData.gridRows[g].dataRows.length);
        for (
          let d = 0;
          d < this.offerEntryData.gridRows[g].dataRows.length;
          d++
        ) {
          this.offerEntryData.gridRows[g].dataRows[d].rowSum =
            loadedOfferEntryData.gridRows[g].dataRows[d].rowSum;
          this.offerEntryData.gridRows[g].dataRows[d].tooltip =
            loadedOfferEntryData.gridRows[g].dataRows[d].tooltip;
          for (let v = 0; v < this.offerEntryData.columnHeaders.length; v++) {
            this.offerEntryData.gridRows[g].dataRows[d].cellColours[v] =
              loadedOfferEntryData.gridRows[g].dataRows[d].cellColours[v];
            this.offerEntryData.gridRows[g].dataRows[d].fontColours[v] =
              loadedOfferEntryData.gridRows[g].dataRows[d].fontColours[v];
            this.offerEntryData.gridRows[g].dataRows[d].shadeColours[v] =
              loadedOfferEntryData.gridRows[g].dataRows[d].shadeColours[v];
            if (
              !(
                this.cellSelection.isCellSelected(
                  this.offerEntryData.gridRows[g].id,
                  d,
                  v
                ) && this.cellSelection.isEdited()
              )
            ) {
              // don't overwrite edits in progress
              this.offerEntryData.gridRows[g].dataRows[d].dataValues[v] =
                loadedOfferEntryData.gridRows[g].dataRows[d].dataValues[v];
              this.offerEntryData.gridRows[g].dataRows[d].roundedDataValues[v] =
                loadedOfferEntryData.gridRows[g].dataRows[d].roundedDataValues[
                  v
                ];
            } else {
              this.utilsService.debugLog(
                "Currently editing column " +
                  this.offerEntryData.intervalIds[v] +
                  ", keeping " +
                  this.offerEntryData.gridRows[g].dataRows[d].roundedDataValues[
                    v
                  ] +
                  ", ignoring " +
                  loadedOfferEntryData.gridRows[g].dataRows[d]
                    .roundedDataValues[v]
              );
            }
          }
        }
      }
      this.utilsService.debugLog(this.offerEntryData);
      this.chartUpdateService.TriggerAnotherUpdate("reloadedGrid");
      // this.cdRef.detectChanges();
    }
  }

  initialiseColumnSelection(): void {
    this.selectedColumns = [];
    this.previouslySelectedColumns = [];
    for (const colHeader of this.offerEntryData.columnHeaders) {
      this.selectedColumns.push(false);
      this.previouslySelectedColumns.push(false);
    }
  }

  dataCellColour(dataRow: DataRow, col): string {
    if (dataRow.cellColours) {
      if (dataRow.cellColours.length > col) {
        return dataRow.cellColours[col];
      }
    }
    return "";
  }

  participationIndicators(dataRow: DataRow, col): string {
    if (dataRow.participationIndicators) {
      if (dataRow.participationIndicators.length > col) {
        return dataRow.participationIndicators[col] ? "#944dff" : "";
      }
    }
    return "";
  }

  dataCellShadeColour(gridRow: GridRow, subRow: number, col: number): string {
    if (this.cellSelection.isCellSelected(gridRow.id, subRow, col)) {
      return "#338FFF"; // see CSS background input colour
    } else if (gridRow.dataRows[subRow].shadeColours) {
      if (gridRow.dataRows[subRow].shadeColours.length > col) {
        return gridRow.dataRows[subRow].shadeColours[col];
      }
    }
    return "";
  }

  dataCellFontColour(gridRow: GridRow, subRow: number, col: number): string {
    if (this.cellSelection.isCellSelected(gridRow.id, subRow, col)) {
      return "white"; // see CSS input color
    } else if (gridRow.dataRows[subRow].fontColours) {
      if (gridRow.dataRows[subRow].fontColours.length > col) {
        return gridRow.dataRows[subRow].fontColours[col];
      }
    }
    return "";
  }

  toggleSubGridDisplay(selectedGridRow: GridRow): void {
    selectedGridRow.subExpanded = !selectedGridRow.subExpanded;
    this.hideSubRows(selectedGridRow);
    if (selectedGridRow.subExpanded) {
      this.collapseAnyUneditedRows(selectedGridRow);
    }
  }

  toggleBidExpansion(selectedGridRow: GridRow): void {
    selectedGridRow.bidExpanded = !selectedGridRow.bidExpanded;
    if (
      this.offerEntryDataService.isAutoCollapseEnabled &&
      selectedGridRow.bidExpanded
    ) {
      this.collapseAnyUneditedRows(selectedGridRow);
    }
  }

  hideSubRows(selectedGridRow: GridRow) {
    for (const gridRow of this.offerEntryData.gridRows) {
      if (selectedGridRow.subGridRows.indexOf(gridRow.id) >= 0) {
        gridRow.isSubGridAndIsVisible = selectedGridRow.subExpanded;
      }
    }
  }

  collapseAnyUneditedRows(selectedGridRow: GridRow) {
    for (const gridRow of this.offerEntryData.gridRows) {
      if (
        selectedGridRow !== gridRow &&
        gridRow.hasManualUpdates.indexOf(true) < 0
      ) {
        gridRow.bidExpanded = false;
        if (
          gridRow.subExpanded &&
          gridRow.subGridRows.indexOf(selectedGridRow.id) < 0
        ) {
          // shrink any open groups unless we are touching something inside that group
          gridRow.subExpanded = false;
          this.hideSubRows(gridRow);
        }
      }
    }
  }

  isGridEntrySelected(id: string, subRow: number, column: number): boolean {
    if (this.cellSelection.isMultiSelected()) {
      return this.cellSelection.isCellSelected(id, subRow, column);
    } else {
      return false;
    }
  }

  // disables the menu
  disableContextMenu($event) {
    if (
      $event.target &&
      $event.target.parentElement &&
      ($event.target.parentElement.localName === "app-context-menu" ||
        $event.target.parentElement.className === "context-menu-list")
    ) {
      return; // allow them to click on the menu itself without closing it
    }
    if (
      this.showDialog === this.Dialog_CellContextMenu ||
      this.showDialog === this.Dialog_ColumnContextMenu ||
      this.showDialog === this.Dialog_GridRowNameContextMenu ||
      this.showDialog === this.Dialog_GridTotalRowNameContextMenu
    ) {
      this.closeAllOpenDialogs(false);
    }
    this.isMouseDownOnCell = false;
    this.isMouseDownOnColumn = false;
  }

  // activates the menu with the coordinates
  oncolumnRightClick($event): boolean {
    if (this.setting.contextMenu) {
      this.prepareContextMenu($event);
      this.showDialog = this.Dialog_ColumnContextMenu;
      return false;
    }
  }

  // activates the menu with the coordinates
  oncellRightClick(
    id: string,
    subrow: number,
    column: number,
    isEditable: boolean,
    $event
  ): boolean {
    if (this.setting.contextMenu) {
      if (this.cellSelection.isEdited()) {
        this.sendSaveChangesMessage();
        this.cellSelection.clearEdits();
      }

      if (!this.cellSelection.isMultiSelected()) {
        this.cellSelection.selectCell(
          this.offerEntryData,
          id,
          subrow,
          column,
          isEditable
        );
        this.setCellContextMenuItems();
      }
      this.prepareContextMenu($event);
      this.showDialog = this.Dialog_CellContextMenu;
      return false;
    }
  }

  // activates the menu with the coordinates
  ongridRowNameRightClick(gridRow: GridRow, $event): boolean {
    if (this.setting.contextMenu) {
      this.prepareContextMenu($event);

      this.rightClickSelectedGridRow = gridRow;
      if (gridRow.isTotalRow) {
        this.showDialog = this.Dialog_GridTotalRowNameContextMenu;
      } else if (gridRow.aggregationlevel === "GROUP") {
        this.showDialog = this.Dialog_GridGroupRowNameContextMenu;
      } else {
        this.showDialog = this.Dialog_GridRowNameContextMenu;
      }
      return false;
    }
  }

  prepareContextMenu($event) {
    this.closeAllOpenDialogs(false);
    this.contextmenuX = $event.pageX;
    this.contextmenuY = $event.pageY - 71; // subtract height of top header (TODO - calculate this)
  }

  public mousedownSelectColumn(column: number, $event) {
    this.closeAllOpenDialogs(false);
    const isRightMB = GridHelper.isRightMouseButton($event);
    this.lastClickWasRight = isRightMB;
    this.currentColumn = column;
    if (GridHelper.isLeftMouseButton($event)) {
      if (!$event.ctrlKey) {
        this.clearSelections();
      }
      this.selectedColumns.forEach((selectedColumn, i) => {
        this.previouslySelectedColumns[i] = this.selectedColumns[i];
      });

      this.selectedColumns[column] = true;
      this.firstSelectedColumn = column;
      this.isMouseDownOnColumn = true;
    }
  }

  public mouseenterSelectColumn(column: number, $event) {
    if (this.isMouseDownOnColumn) {
      if (GridHelper.isLeftMouseButton($event)) {
        this.lastSelectedColumn = column;
        let start = this.lastSelectedColumn;
        let finish = this.firstSelectedColumn;
        if (this.lastSelectedColumn > this.firstSelectedColumn) {
          start = this.firstSelectedColumn;
          finish = this.lastSelectedColumn;
        }
        this.selectedColumns.forEach((selectedColumn, i) => {
          this.selectedColumns[i] =
            (i >= start && i <= finish) || this.previouslySelectedColumns[i];
        });
      } else {
        this.clearMouseDown();
      }
    }
  }

  public mouseupSelectColumn(column: number, event) {
    this.clearMouseDown();
    this.setColumnContextMenuItems();
  }

  clearMouseDown() {
    if (this.debugMouseEvents) {
      this.utilsService.debugLog("Mouseup");
    }
    this.ignoreNextBlur = false;
    this.isMouseDownOnCell = false;
    this.isMouseDownOnColumn = false;
  }

  public toggleCharting(selectedGridRow: GridRow, $event) {
    if (this.setting.charting && $event.target.nodeName !== "BUTTON") {
      // make sure we aren't capturing child clicks like the group expand button
      if (selectedGridRow.isSubGrid) {
        return; // ignore subgrid clicks
      }
      if (selectedGridRow.isTotalRow) {
        // show all rows
        let allVisible = true;
        for (const row of this.offerEntryData.gridRows) {
          if (!row.isVisibleOnChart && !row.isTotalRow) {
            allVisible = false;
          }
        }
        if (allVisible) {
          // if all are already visible then toggle display of total row
          selectedGridRow.isVisibleOnChart = !selectedGridRow.isVisibleOnChart;
        } else {
          // make all visible again
          for (const row of this.offerEntryData.gridRows) {
            row.isVisibleOnChart = true;
          }
        }
      } else if ($event.shiftKey) {
        let allHidden = true;
        for (const row of this.offerEntryData.gridRows) {
          if (row.isVisibleOnChart && row !== selectedGridRow) {
            allHidden = false;
          }
        }
        if (allHidden) {
          // if all already hidden then bring them back
          for (const row of this.offerEntryData.gridRows) {
            row.isVisibleOnChart = true;
          }
        } else {
          // hide all but the current selection
          selectedGridRow.isVisibleOnChart = true;
          for (const row of this.offerEntryData.gridRows) {
            if (row.id !== selectedGridRow.id) {
              row.isVisibleOnChart = false;
            }
          }
        }
      } else {
        selectedGridRow.isVisibleOnChart = !selectedGridRow.isVisibleOnChart;
      }
      this.chartUpdateService.TriggerAnotherUpdate("showHideChange");
    }
  }

  public mousedownSelectCell(
    id: string,
    subrow: number,
    column: number,
    isEditable: boolean,
    $event
  ): boolean {
    if (this.debugMouseEvents) {
      this.utilsService.debugLog(
        "Mousedown cell: " + id + ", " + subrow + ", " + column
      );
    }
    if (this.cellSelection.isEdited()) {
      this.sendSaveChangesMessage();
      this.cellSelection.clearEdits();
    }
    const mouseDownTarget =
      $event.target || $event.srcElement || $event.currentTarget;
    this.closeAllOpenDialogs(false);
    const isRightMB = GridHelper.isRightMouseButton($event);

    this.lastClickWasRight = isRightMB;

    if (isRightMB) {
      if (this.cellSelection.isCellSelected(id, subrow, column)) {
        return false;
      } else {
        this.cellSelection.clearSelection();
      }
    }

    if ($event.shiftKey) {
      this.cellSelection.extendSelectionToColumn(id, subrow, column);
      return false;
    }

    const cellToFocus = <HTMLInputElement>(mouseDownTarget as Element);
    if (cellToFocus) {
      cellToFocus.focus();
      if (!isRightMB) {
        cellToFocus.select();
      }
    }
    this.ignoreNextBlur = true;

    if (!isRightMB) {
      this.closeAllOpenDialogs(false);
      this.clearSelections();

      this.cellSelection.selectCell(
        this.offerEntryData,
        id,
        subrow,
        column,
        isEditable
      );
      this.setCellContextMenuItems();
      this.isMouseDownOnCell = true;
    }

    return false;
  }

  public mouseenterSelectCell(
    id: string,
    subrow: number,
    column: number,
    $event
  ) {
    if (GridHelper.isLeftMouseButton($event)) {
      if (this.isMouseDownOnCell) {
        if (this.debugMouseEvents) {
          this.utilsService.debugLog(
            "Mouseenter cell: " + id + ", " + subrow + ", " + column
          );
        }
        this.cellSelection.extendSelectionToColumn(id, subrow, column);
      }
    }
  }

  public mouseupSelectCell(
    id: string,
    subrow: number,
    column: number,
    $event
  ): boolean {
    if (this.cellSelection.canEdit) {
      const selection = this.cellSelection.getSelection(this.offerEntryData);
      if (selection.gridRow !== undefined) {
        this.cellActionEvent.emit({
          action: "ENTER-CELL",
          gridRow: selection.gridRow,
          rowIdx: selection.row,
          colIdxs: selection.cols,
        });
        // this.messageHandler('ENTER-CELL', selection.gridRow, selection.row, selection.cols);
      }
    }

    if (this.debugMouseEvents) {
      this.utilsService.debugLog(
        "Mouseup cell: " + id + ", " + subrow + ", " + column
      );
    }
    this.clearMouseDown();
    return false;
  }

  public cellBlur($event) {
    if (this.debugMouseEvents) {
      this.utilsService.debugLog(
        "Cell Blur: MD " +
          this.isMouseDownOnCell +
          ", LR " +
          this.lastClickWasRight +
          ", evt: " +
          $event +
          ", edit: " +
          this.cellSelection.isEdited()
      );
    }

    if (this.cellSelection.isEdited()) {
      this.sendSaveChangesMessage();
      this.cellSelection.clearEdits();
      // this.notifyMessageServiceOfEdit();
    }

    if (
      !this.isMouseDownOnCell &&
      !this.lastClickWasRight &&
      !this.ignoreNextBlur
    ) {
      this.clearSelections();
    }
    this.ignoreNextBlur = false;
  }

  notifyMessageServiceOfEdit() {
    const selection = this.cellSelection.getSelection(this.offerEntryData);
    if (selection.gridRow) {
      this.cellActionEvent.emit({
        action: "EDITED",
        gridRow: selection.gridRow,
        rowIdx: selection.row,
        colIdxs: selection.cols,
      });
      // this.messageHandler('EDITED', selection.gridRow, selection.row, selection.cols);
    }
  }

  emitCellEditingEvent() {
    const selection = this.cellSelection.getSelection(this.offerEntryData);
    if (selection.gridRow) {
      this.cellActionEvent.emit({
        action: "EDITING",
        gridRow: selection.gridRow,
        rowIdx: selection.row,
        colIdxs: selection.cols,
      });
      // this.messageHandler('EDITING', selection.gridRow, selection.row, selection.cols);
    }
  }

  public onCellChange(newValue: number): void {
    if (this.debugMouseEvents) {
      this.utilsService.debugLog("Cell Changed");
    }
    this.cellSelection.setEdited();

    this.emitCellEditingEvent();

    if (this.cellSelection.isMultiSelected()) {
      this.cellSelection.setSelection(this.offerEntryData, newValue);
    }
    this.cellSelection.updateRawFromRoundedSelection(this.offerEntryData); // make sure charted value is up to date
    this.chartUpdateService.TriggerAnotherUpdate("cellChange");
  }

  public onFocus(gridRow: GridRow, row, col, event) {
    if (this.cellSelection.isEdited()) {
      this.sendSaveChangesMessage();
      this.cellSelection.clearEdits();
    }

    if (
      !this.cellSelection.isMultiSelected() &&
      this.getIsEditable(gridRow, row, col)
    ) {
      this.cellSelection.selectCell(
        this.offerEntryData,
        gridRow.id,
        row,
        col,
        this.getIsEditable(gridRow, row, col)
      );
      // this.utilsService.debugLog(GridHelper.isLeftMouseButton(event));
      if (event.sourceCapabilities) {
        // TODO: This is a temporary solution for distinguishing event trigger
        this.cellActionEvent.emit({
          action: "ENTER-CELL",
          gridRow: gridRow,
          rowIdx: row,
          colIdxs: [col],
        });
        // this.messageHandler('ENTER-CELL', data, row, [col]);
      }
    }
  }

  public isEditing(data: GridRow, column: number): string {
    if (this.setting.message && this.users) {
      const isPortfolioView =
        this.offerEntryData.loadedPortfolioID === "" ||
        this.offerEntryData.loadedPortfolioID === "-1"
          ? true
          : false;
      const users = this.users.filter((user) => {
        if (isPortfolioView && user.level !== "PORTFOLIO") {
          return false;
        }
        if (user.key === data.id) {
          const idx = user.columns.indexOf(column);
          if (
            idx !== -1 &&
            user.date[idx] ===
              this.messageService.getFormatedDate(this.selectedDate)
          ) {
            return true;
          }
        }
        return false;
      });

      if (users.length > 0) {
        if (users[0].isEditing) {
          return "5px solid " + users[0].color;
        } else {
          return "2px solid " + users[0].color;
        }
      }
    }
    return "1px solid #D9D9D9";
  }

  trackByFn(index: any, item: any) {
    return index;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/offer-entry-grid/offer-entry-grid.component.ts